import React from "react";
import AntdProgress from 'antd/lib/progress';
import { withError} from '@fishx/tracker';

const Progress = (props) => <AntdProgress {...props} />
Progress.displayName = 'Progress';
export default withError(Progress);


// WEBPACK FOOTER //
// ./src/components/progress/index.tsx